import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.6665 11.4999L11.6665 13.4999L16.1665 8.99987M20.6665 11.9999C20.6665 16.9083 15.3125 20.4783 13.3645 21.6147C13.1431 21.7439 13.0324 21.8085 12.8762 21.842C12.7549 21.868 12.5781 21.868 12.4568 21.842C12.3006 21.8085 12.1899 21.7439 11.9685 21.6147C10.0205 20.4783 4.6665 16.9083 4.6665 11.9999V7.21747C4.6665 6.41796 4.6665 6.0182 4.79726 5.67457C4.91278 5.37101 5.10049 5.10015 5.34416 4.8854C5.62 4.64231 5.9943 4.50195 6.74291 4.22122L12.1047 2.21054C12.3126 2.13258 12.4165 2.0936 12.5235 2.07815C12.6183 2.06444 12.7147 2.06444 12.8095 2.07815C12.9165 2.0936 13.0204 2.13258 13.2283 2.21054L18.5901 4.22122C19.3387 4.50195 19.713 4.64231 19.9888 4.8854C20.2325 5.10015 20.4202 5.37101 20.5357 5.67457C20.6665 6.0182 20.6665 6.41796 20.6665 7.21747V11.9999Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShieldTick;
